/* eslint-disable jsx-a11y/alt-text */
import React from "react";
import Header from "@img/headerdesapreneur.png";
import Objective1 from "@img/tujuand1.png";
import Objective2 from "@img/tujuand2.png";
import Objective3 from "@img/tujuand3.png";
import Objective4 from "@img/tujuand4.png";
import Objective5 from "@img/tujuand5.png";
import FloatingMenu from "../components/FloatingMenu";
import { useEffect, useState } from "react";

const Desapreneur = () => {
  const [desaPreneur, setDesaPreneur] = useState([]);

  useEffect(() => {
    fetchDesaPreneur();
  }, []);

  const fetchDesaPreneur = async () => {
    try {
      const response = await fetch(
        "https://cms.okoce.net/api/admin/desapreneurs"
      );
      if (!response.ok) {
        throw new Error("Gagal mengambil data desapreneur");
      }
      const data = await response.json();
      setDesaPreneur(data.data[0] || []);
    } catch (error) {
      setDesaPreneur([]);
    }
  };

  const objectiveImages = [
    Objective1,
    Objective2,
    Objective3,
    Objective4,
    Objective5,
  ];

  return (
    <>
      <div className="flex overflow-hidden relative flex-col justify-center items-center px-16 py-20 text-center text-white min-h-[677px] max-md:px-5">
        <img
          loading="lazy"
          src={Header}
          className="object-cover absolute inset-0 size-full"
        />
        <div className="flex relative flex-col mt-36 w-full max-w-[1133px] max-md:mt-10 max-md:max-w-full">
          <div className="text-4xl font-bold leading-10 max-md:max-w-full">
            {desaPreneur.title}
          </div>
          <div
            className="self-center mt-8 text-xl leading-6 max-md:max-w-full"
            dangerouslySetInnerHTML={{ __html: desaPreneur.description }}
          />
        </div>
      </div>
      {/* Tujuan */}
      <div className="flex flex-col ml-5 mr-5 mt-5 px-11 py-10 max-md:px-5">
        <div className="text-5xl ml-8 font-bold text-black leading-[57.6px] max-md:max-w-full max-md:text-4xl">
          Tujuan Program
        </div>
        <div className="mt-12 text-lg ml-8 leading-4 text-neutral-700 max-md:mt-10 max-md:max-w-full">
          Program Desa Preuner Bertujuan Untuk:
        </div>
        <div className="mt-11 max-md:mt-10 max-md:mr-2 max-md:max-w-full">
          <div className="flex flex-wrap justify-center gap-5 max-md:flex-col max-md:gap-0">
            {desaPreneur?.objective?.map(({ objective_description }, index) => (
              <div key={index} className="flex flex-col max-w-[581px] w-full">
                <div className="flex flex-col grow py-9 px-10 w-full text-2xl leading-9 text-justify text-black bg-white rounded-3xl border border-indigo-800 border-solid shadow-sm max-md:px-5 max-md:mt-10">
                  <img
                    loading="lazy"
                    src={objectiveImages[index % objectiveImages.length]}
                    className="w-10 aspect-square"
                    alt={`Key ${(index % objectiveImages.length) + 1}`}
                  />
                  <div
                    className="mt-4 max-md:max-w-full"
                    dangerouslySetInnerHTML={{
                      __html: objective_description,
                    }}
                  />
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      {/* Tujuan end */}
      {/* Manfaat */}
      <div className="flex flex-col ml-2 mr-2 px-12 pt-7 pb-20 bg-[#1c75ac] max-md:px-5">
        <div className="text-2xl font-bold leading-8 text-white max-md:max-w-full">
          Manfaat Program Desa Preneur
        </div>
        <div className="mt-12 text-xl leading-8 text-justify text-white max-md:mt-10 max-md:max-w-full">
          Dengan berpartisipasi dalam Program Desa Preuner, warga desa dapat
          menikmati berbagai manfaat, antara lain:
        </div>
        <div className="mt-24 max-md:mt-10 max-md:max-w-full">
          <div className="flex gap-4 max-md:flex-col max-md:gap-0">
            {desaPreneur?.benefit?.map(
              ({ benefit_title, benefit_description }, index) => (
                <div
                  key={index}
                  className="flex flex-col w-[33%] max-md:ml-0 max-md:w-full"
                >
                  <div className="flex flex-col grow text-white max-md:mt-10">
                    <div className="text-2xl font-bold leading-8">
                      {benefit_title}
                    </div>
                    <div
                      className="mt-10 text-lg leading-7 text-justify max-md:mt-10"
                      dangerouslySetInnerHTML={{
                        __html: benefit_description,
                      }}
                    />
                  </div>
                </div>
              )
            )}
          </div>
        </div>
      </div>
      {/* Manfaaat End */}
      <FloatingMenu />{" "}
    </>
  );
};

export default Desapreneur;
